import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import ReduxThunk from 'redux-thunk';
import App from './containers/app';
import rootReducers from './reducers';
import initialState from './reducers/initial_state';
import { getFormSetting } from './actions';

const middlewares = [ReduxThunk];
if (window.location.port === '8080') {
  middlewares.push(logger);
}
const store = createStore(
  rootReducers,
  initialState,
  applyMiddleware(...middlewares)
);

const target = document.getElementById('js-contact');
if (target) {
  render(
    <Provider store={store}>
      <App />
    </Provider>,
    target
  );

  store.dispatch(getFormSetting());
} else {
  console.warn('contact target not found');
}
